<app-product-gallery [product]="product"></app-product-gallery>

<app-product-details [product]="product" [sku]="sku"></app-product-details>